<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/item">{{ $t('item_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('cost_item_histories') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print"><i class="fa fa-print" aria-hidden="true"></i> {{$t('print')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <h3 class="text-center font-m">{{$t('cost_item_histories')}}</h3>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center">{{$t('no')}}</th>
                                        <th>{{$t('item_code')}}</th>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('ref_num')}}</th>
                                        <th>{{$t('date')}}</th>
                                        <th>{{$t('vendor')}}</th>
                                        <th class="text-right">{{$t('begin_stock')}}</th>
                                        <th class="text-right">{{$t('begin_cost')}}</th>
                                        <th class="text-right">{{$t('total_cost_begin')}}</th>
                                        <th class="text-right">{{$t('qty_in')}}</th>
                                        <th class="text-right">{{$t('cost_in')}}</th>
                                         <th class="text-right">{{$t('total_cost_in')}}</th>
                                        <th class="text-right">{{$t('ending_stock')}}</th>
                                        <th class="text-right">{{$t('ending_cost')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in records" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.ItemCode}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td>{{ret.DocSourceNo}}</td>
                                        <td>{{$format(ret.Date,'DD-MM-YYYY')}}</td>
                                        <td>{{ret.VendorName}}</td>
                                        <td class="text-right">{{$number(ret.BeginStock, '0,0.00')}}</td>
                                        <td class="text-right">{{$money(ret.BeginCost)}}</td>
                                        <td class="text-right">{{$money(ret.TotalCostBegin)}}</td>
                                        <td class="text-right">{{$number(ret.StockinQty, '0,0.00')}}</td>
                                        <td class="text-right">{{$money(ret.StockinCost)}}</td>
                                        <td class="text-right">{{$money(ret.TotalStockinCost)}}</td>
                                        <td class="text-right">{{$number(ret.EndingStock, '0,0.00')}}</td>
                                        <td class="text-right">{{$money(ret.EndingCost)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br/>
                    <div>
                        {{$t('note')}}:
                        <div> - {{$t('total_cost_begin')}} = {{$t('begin_stock')}} * {{$t('begin_cost')}}</div>
                        <div> - {{$t('total_cost_in')}} = {{$t('qty_in')}} * {{$t('cost_in')}}</div>
                        <div> - {{$t('ending_cost')}} = ({{$t('total_cost_begin')}} + {{$t('total_cost_in')}}) / {{$t('ending_stock')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            beginStock: 0,
            records: []
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            let loading = this.$loading.show();
            this.$api().post('item/cost/histories', { Id: this.$route.params.id }).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Costs;
                }
            }).finally(()=>{ loading.hide(); });
        },
        print(){

        }
    }
}
</script>